import Vue from "vue";

Vue.filter("itemImageHeight", function(itemImages, highestPosition)
{
    if (!Array.isArray(itemImages) || itemImages.length === 0)
    {
        return null;
    }

    if (itemImages.length === 1)
    {
        return itemImages[0].height || null;
    }

    const image = itemImages.reduce((prev, current) =>
        highestPosition
            ? (prev.position > current.position ? prev : current)
            : (prev.position < current.position ? prev : current)
    );

    return image.height || null;
});
